/** Normalizes PUT /internalInquiries/:id/fractional-processing-fees response (total and/or per-block fee). */
export default function fractionalProcessingFeesTransformer(response) {
  const data = response?.data ?? response
  const totalRaw =
    data?.processingFeeTotal ??
    data?.totalProcessingFee ??
    data?.total ??
    data?.processingFee ??
    data?.processing_fee
  const perBlockRaw =
    data?.processingFeePerBlock ??
    data?.feePerBlock ??
    data?.processing_fee_per_block

  const parseNum = v => {
    if (v == null || v === "") return null
    const n = typeof v === "number" ? v : parseFloat(v, 10)
    return Number.isFinite(n) ? n : null
  }

  const processingFeeTotal = parseNum(totalRaw)
  const processingFeePerBlock = parseNum(perBlockRaw) ?? 0

  return { processingFeeTotal, processingFeePerBlock }
}
